import { render, staticRenderFns } from "./otd-list.vue?vue&type=template&id=120b93dc&scoped=true"
import script from "./otd-list.vue?vue&type=script&lang=ts"
export * from "./otd-list.vue?vue&type=script&lang=ts"
import style0 from "./otd-list.vue?vue&type=style&index=0&id=120b93dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b93dc",
  null
  
)

export default component.exports